export default __webpack_public_path__ + "media/images/progress-1-e37faee56fe53978e00876630b352dcb.png";